import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { numberFormatter } from '../../../../../utils/number';
import detractionBasicInformationPropTypes from '../proptypes/ExchangeRatePropTypes';

const ExchangeRateBasicInformationResource = ({
  currency, rate
}) => (
  <>
      <ResourceProperty label="País:">{currency}</ResourceProperty>
    <ResourceProperty label="Tasa:">
      {numberFormatter({
        value: rate,
        style: 'currency',
      })}
    </ResourceProperty>
  </>
);

ExchangeRateBasicInformationResource.propTypes =
  detractionBasicInformationPropTypes;

export default ExchangeRateBasicInformationResource;
